export default {
  INIT: 'DIMBOX/INIT',
  UPDATE_DIMBOXES: 'DIMBOX/UPDATE_DIMBOXES',
  SELECT_CABINET: 'DIMBOX/SELECT_CABINET',
}
